import { mediaQuery } from 'constants/ui';

import { sharedSectionWrapperStyles } from '../LoanSummary.styles';

export const wrapperStyles = {
  gridColumn: 'span 4',
  ...sharedSectionWrapperStyles,

  // Override LoanInfoCards grid to show 1 column on mobile
  '& > div:last-child': {
    [mediaQuery.mobile]: {
      gridTemplateColumns: 'repeat(1, 1fr)',
    },
  },
};

export const dividerStyles = {
  borderColor: ({ palette }) => palette.border.default,
};

export const loanInfoCardStyles = {
  '& .text-value': {
    fontSize: '1.8rem !important',
  },
};
